import React from "react"
import PropTypes from "prop-types"
import { TagFootNoteContainer, Tags, Tag, Footnote } from "./style"
import { Link } from "gatsby"

const TagFootNote = ({ tags }) => {
  return (
    <TagFootNoteContainer>
      <Tags>
        {tags && tags.nodes.map((tag, index) => {
          return (
            <Tag key={index}>
              <Link to={`/search?q=${tag.name}`}>{tag.name}</Link>
            </Tag>
          )
        })}
      </Tags>
      {/* <Footnote>1. The best of Canberra, New Holland Publishers</Footnote> */}
    </TagFootNoteContainer>
  )
}

export default TagFootNote
